/*
Integrations for destinations to allow events to be forwarded to (https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#managing-data-flow-with-the-integrations-object:~:text=%7B%0A%20%20integrations%3A%20%7B%0A%20%20%20%20%27Intercom%27%3A%20false%2C%0A%20%20%20%20%27Google%20Analytics%27%3A%20false%0A%20%20%7D)
*/
enum SegmentIntegration {
  GoogleAnalytics = 'Google Analytics 4 Cloud',
}

export const integrations = {
  [SegmentIntegration.GoogleAnalytics]: true,
};
